/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/

import 'quasar-framework/dist/quasar.ie.polyfills.js'



import 'quasar-extras/roboto-font/roboto-font.css'

import 'quasar-extras/material-icons/material-icons.css'




import 'quasar-app-styl'


import 'src/css/app.styl'


import Vue from 'vue'
import createApp from './app.js'




import pAxios from 'src/plugins/axios'

import pFontawesomepro from 'src/plugins/fontawesome-pro'

import pVueflagicon from 'src/plugins/vue-flag-icon'

import pI18next from 'src/plugins/i18next'

import pQs from 'src/plugins/qs'

import pVuelidate from 'src/plugins/vuelidate'

import pTruncatelink from 'src/plugins/truncate-link'

import pExtensionicon from 'src/plugins/extension-icon'

import pVuecssdonutchart from 'src/plugins/vue-css-donut-chart'

import pVueplyr from 'src/plugins/vue-plyr'

import pVuescrollto from 'src/plugins/vue-scrollto'

import pVuecarousel from 'src/plugins/vue-carousel'

import pVuefire from 'src/plugins/vuefire'

import pVuehtml2canvas from 'src/plugins/vue-html2canvas'

import pSlugify from 'src/plugins/slugify'

import pOffline from 'src/plugins/offline'

import pVueyoutube from 'src/plugins/vue-youtube'

import pVueanalytics from 'src/plugins/vue-analytics'

import pMimetypes from 'src/plugins/mime-types'

import pVuecountdown from 'src/plugins/vue-countdown'

import pVuerecaptcha from 'src/plugins/vue-recaptcha'

import pClearemoticons from 'src/plugins/clear-emoticons'

import pFullcalendar from 'src/plugins/fullcalendar'

import pSocialsharing from 'src/plugins/social-sharing'

import pVuezoomer from 'src/plugins/vue-zoomer'

import pVuezendesk from 'src/plugins/vue-zendesk'

import pJwplayer from 'src/plugins/jwplayer'

import pJitsi from 'src/plugins/jitsi'

import pVueclipboard2 from 'src/plugins/vue-clipboard2'

import pForminputerrorfocus from 'src/plugins/form-input-error-focus'

import pComparestoredcolumns from 'src/plugins/compare-stored-columns'

import pVuemask from 'src/plugins/vue-mask'

import pMask from 'src/plugins/mask'

import pButtondelay from 'src/plugins/button-delay'














const { app, store, router } = createApp()




;[pAxios,pFontawesomepro,pVueflagicon,pI18next,pQs,pVuelidate,pTruncatelink,pExtensionicon,pVuecssdonutchart,pVueplyr,pVuescrollto,pVuecarousel,pVuefire,pVuehtml2canvas,pSlugify,pOffline,pVueyoutube,pVueanalytics,pMimetypes,pVuecountdown,pVuerecaptcha,pClearemoticons,pFullcalendar,pSocialsharing,pVuezoomer,pVuezendesk,pJwplayer,pJitsi,pVueclipboard2,pForminputerrorfocus,pComparestoredcolumns,pVuemask,pMask,pButtondelay].forEach(plugin => {
  plugin({
    app,
    router,
    store,
    Vue,
    ssrContext: null
  })
})









new Vue(app)






